export default {"src":"/_next/static/media/government.4e8da329.svg","height":568,"width":608,"blurWidth":0,"blurHeight":0};